/** @jsxImportSource @emotion/react */
import { type, userInfo } from "os";
import { ChangeEvent, useState, useEffect, useRef, FormEvent, Dispatch, SetStateAction, BaseSyntheticEvent } from "react";
import { useForm, SubmitHandler, useFieldArray, Controller } from "react-hook-form";
import { CreateFileListFromBlobObject, HttpPostData, JumpPage, UploadFile, baseFrontAppUrl } from "../common/Util";
import { ResponseParamBase, SelectItemType } from "../common/Types";
import { ApiUrl, RouterUrl } from "../common/Params";
import { fileListRow, TokenGaugeData, UploadFileComponent } from "./components/UploadFile";
import { ColorPicker, ColorType } from "./components/ColorPicker";
import { UploadImage, UploadImageType } from "./components/UploadImage";
import { BaseInfo, BaseInfoProps } from "./components/BaseInfo";
import { InitMessages, InitMessagesProp, ArrayFieldRowType } from "./components/InitMessages";
import { TextEdit, TextEditType } from "./components/TextEdit";
import { Snack } from "./components/Snack";
import { useNavigate } from "react-router-dom";
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton, AccordionItemState, AccordionItemPanel } from "react-accessible-accordion";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from "yup";
import { TextValidation } from "../common/Validation";
import { ChatData, ChatMessageType, ChatPreview } from "./components/ChatPreview";
import configcss from "../css/config.module.css";
import accordioncss from "../css/accordion.module.css";
import Fab from '@mui/material/Fab';
import SaveIcon from '@mui/icons-material/Save';
import { css } from "@emotion/react";
import { CircularProgress } from "@mui/material";
import basecss from "../css/base.module.css";
import erroricon from "../img/error.svg";
import { InitResponseParam } from "./Main";
import { WindowResize } from "./hooks/WindowResize";
import { OpenAiSetting, OpenAiSettingData, OpenAiTier } from "./components/OpenAiSetting";

type ResponseParam = InitResponseParam & {
    fileList: fileListRow[],
    tokenGauge: TokenGaugeData,
    siteId: string,
    siteName: string,
    //chatModelItems: SelectItemType[],
    //openAiSetting: OpenAiSettingData,
}

type LoginResponseParam = ResponseParamBase & {

}
/*
type ResponseParam = ResponseParamBase & {
    filelist: fileListRow[],
    colorlist: string[],
    inittextlist: string[],
    title: string,
    footertext: string,
    headercolor: string,
    backgroundcolor: string,
    adminbubblebackgroundcolor: string,
    adminbubbletextcolor: string,
    guestbubblebackgroundcolor: string,
    guestbubbletextcolor: string,
    footerbackgroundcolor: string,
    footertextcolor: string,
    sendbuttoncolor: string,
    siteid: string,
    sitename: string,
}
*/

export type IFormInputs = {
    questionTemplate: string,
    chatTitle: string,
    headerTextColor: string,
    initMessageList: ArrayFieldRowType[],
    footerText: string,
    headerColor: string,
    backgroundColor: string,
    adminBubbleBackgroundColor: string,
    adminBubbleTextColor: string,
    guestBubbleBackgroundColor: string,
    guestBubbleTextColor: string,
    footerBackgroundColor: string,
    footerTextColor: string,
    footerTextareaColor: string,
    footerTextareaPlaceholderColor: string,
    sendButtonColor: string,
    headerIcon: FileList | null,
    chatAdminIcon: FileList | null,
    chatGuestIcon: FileList | null,
    sendButtonIcon: FileList | null,
}

const schema = Yup.object().shape({
    chatTitle: TextValidation(true, 1, 30),
    questionTemplate: TextValidation(true, 1, 800),
    initMessageList: Yup.array(
        Yup.object().shape({
            msgtext: TextValidation(true, 1, 100),
        })
    ),
    footerText: TextValidation(true, 1, 30),    
})

export type LogoutResponseParam = ResponseParamBase & {

}

export const Config = () => {

    const navigate = useNavigate();

    const logout = async (e: FormEvent) => {
        await UploadFile<LogoutResponseParam>(
            ApiUrl.Logout,
            {
                'refresh': localStorage.getItem('refreshtoken'),
                'access': localStorage.getItem('accesstoken'),
            },
            setIsLoading,
        ).then((response) => {
            localStorage.removeItem('accesstoken');
            localStorage.removeItem('refreshtoken');
            window.location.reload();
            //JumpPage(RouterUrl.Upload, null, navigate);
        });
    }

    const [windowWidth, windowHeight] = WindowResize();
    const previewDivRef = useRef<HTMLDivElement>(null);

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSaving, setIsSaving] = useState<boolean>(false);
    const [questionTemplate, setQuestionTemplate] = useState<string>("");
    const [backgroundColor, setBackgroundColor] = useState<string>("");
    const [adminbubblebackgroundcolor, setAdminbubblebackgroundcolor] = useState<string>("");
    const [adminbubbletextcolor, setAdminbubbletextcolor] = useState<string>("");
    const [guestbubblebackgroundcolor, setGuestbubblebackgroundcolor] = useState<string>("");
    const [guestbubbletextcolor, setGuestbubbletextcolor] = useState<string>("");
    const [footerBackgroundColor, setFooterBackgroundColor] = useState<string>("");
    const [footertextcolor, setFootertextcolor] = useState<string>("");
    const [footerTextareaColor, setFooterTextareaColor] = useState<string>("");
    const [footerTextareaPlaceholderColor, setFooterTextareaPlaceholderColor] = useState<string>("");
    const [sendbuttoncolor, setSendbuttoncolor] = useState<string>("");
    const [headercolor, setHeadercolor] = useState<string>("");    
    const [title, setTitle] = useState<string>("");
    const [headerTextColor, setHeaderTextColor] = useState<string>("");
    const [footerText, setFooterText] = useState<string>("");
    const [colorList, setColorlist] = useState<string[]>([]);
    const [inittextList, setInittextList] = useState<ArrayFieldRowType[]>([{ msgtext: "" }]);
    const [headerImage, setHeaderImage] = useState<Blob>(new Blob());
    const [adminChatIcon, setAdminChatIcon] = useState<Blob>(new Blob());
    const [guestChatIcon, setGuestChatIcon] = useState<Blob>(new Blob());
    const [footerButtonIcon, setFooterButtonIcon] = useState<Blob>(new Blob());
    const [fileList, setFileList] = useState<fileListRow[]>([]);
    const [siteProp, setSiteProp] = useState<BaseInfoProps>({siteId: "", siteName: "", logoutListner: logout});

    /*const [currentToken, setCurrentToken] = useState<number>(0);
    const [maxToken, setMaxToken] = useState<number>(30000);
    const [tokenParse, setTokenParse] = useState<number>(0);*/
    const [tokenGauge, setTokenGauge] = useState<TokenGaugeData>({
        currentToken: 0,
        maxToken: 400000,
        tokenParse: 0,
        tokenProgressColor: "#52b202",
    });
    const [openAiSetting, setOpenAiSetting] = useState<OpenAiSettingData>({
        apiKey: "",
        chatModel: "",
        tier: 1,
        isRequiredApiKey: true,
        isTrial: true,
        trialLimit: null,
    });
    const [chatModelItems, setChatModelItems] = useState<SelectItemType[]>([]);
    const [siteId, setSiteId] = useState<string>("");
    const [siteName, setSiteName] = useState<string>("");

    const [isSnackOpen, setIsSnackOpen] = useState<boolean>(false);

    const sendButton = css`
        position: fixed;
        top: 20px;
        left: 20px;
    `

    const { register, handleSubmit, trigger, setValue, control, getValues, watch, formState: { errors, isValid } } = useForm<IFormInputs>({
        defaultValues: {
            questionTemplate: "",
            chatTitle: title,
            initMessageList: inittextList,
            footerText: footerText,
            headerColor: headercolor,
            headerTextColor: headerTextColor,
            backgroundColor: backgroundColor,
            adminBubbleBackgroundColor: adminbubblebackgroundcolor,
            adminBubbleTextColor: adminbubbletextcolor,
            guestBubbleBackgroundColor: guestbubblebackgroundcolor,
            guestBubbleTextColor: guestbubbletextcolor,
            footerBackgroundColor: footerBackgroundColor,
            footerTextColor: footertextcolor,
            footerTextareaColor: footerTextareaColor,
            footerTextareaPlaceholderColor: footerTextareaPlaceholderColor,
            sendButtonColor: sendbuttoncolor,
            headerIcon: null,
            chatAdminIcon: null,
            chatGuestIcon: null,
            sendButtonIcon: null,
        },
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: yupResolver(schema),
    });

    /*const { fields, append, remove, replace } = useFieldArray({
        name: "initMessageList",
        control: control,
    });*/
    const fieldArray = useFieldArray({
        name: "initMessageList",
        control: control,
    })
    
    useEffect(() => {
        (async () => {
            await UploadFile<ResponseParam>(ApiUrl.IsLogin, {}, setIsLoading)
            await init();
        })()
    }, [])

    async function init() {
        setIsLoading(true);
        Promise.all([
            await UploadFile<ResponseParam>(ApiUrl.UserFileList, {}, null),
            await UploadFile<Blob>(ApiUrl.GetHeaderImage, { "imageType": UploadImageType.headerImage }, null, "blob"),
            await UploadFile<Blob>(ApiUrl.GetHeaderImage, { "imageType": UploadImageType.chatAdminIcon }, null, "blob"),
            await UploadFile<Blob>(ApiUrl.GetHeaderImage, { "imageType": UploadImageType.chatGuestIcon }, null, "blob"),
            await UploadFile<Blob>(ApiUrl.GetHeaderImage, { "imageType": UploadImageType.sendButtonIcon }, null, "blob"),
        ]).then(([initParamResponse, headerImageResponse, adminIconResponse, guestAdminIconResponse, footerButtonIconResponse]) => {
            /*setFileList((value) => { return [...initParamResponse.data.filelist] });
            setTitle((value) => { return initParamResponse.data.title });
            setColorlist((value) => { return initParamResponse.data.colorlist });
            setInittextList((value) => { return initParamResponse.data.inittextlist.map<ArrayFieldRowType>((value) => { return { msgtext: value } }) });
            setHeadercolor((value) => { return initParamResponse.data.headercolor })
            setBackgroundColor((value) => { return initParamResponse.data.backgroundcolor });
            setAdminbubblebackgroundcolor((value) => { return initParamResponse.data.adminbubblebackgroundcolor });
            setAdminbubbletextcolor((value) => { return initParamResponse.data.adminbubbletextcolor });
            setGuestbubblebackgroundcolor((value) => { return initParamResponse.data.guestbubblebackgroundcolor });
            setGuestbubbletextcolor((value) => { return initParamResponse.data.guestbubbletextcolor });
            setFooterText((value) => { return initParamResponse.data.footertext });
            setFooterBackgroundColor((value) => { return initParamResponse.data.footerbackgroundcolor });
            setFootertextcolor((value) => { return initParamResponse.data.footertextcolor });
            setBaseInfoProp((value) => { return { siteId: initParamResponse.data.siteid, siteName: initParamResponse.data.sitename } });
            setHeaderImage((value) => { return headerImageResponse.data });
            setAdminChatIcon((value) => { return adminIconResponse.data });
            setGuestChatIcon((value) => { return guestAdminIconResponse.data });
            setFooterButtonIcon((value) => { return footerButtonIconResponse.data });*/

            setFileList((value) => { return [...initParamResponse.data.fileList] });
            setTokenGauge((value) => {return initParamResponse.data.tokenGauge});
            //setChatModelItems((value) => {return initParamResponse.data.chatModelItems});
            //setOpenAiSetting((value) => {return initParamResponse.data.openAiSetting});
            /*setCurrentToken((value) => { return initParamResponse.data.currentToken });
            setMaxToken((value) => { return initParamResponse.data.maxToken });
            setTokenParse((value) => {return initParamResponse.data.tokenParse});*/
            setSiteProp((value) => {return {siteId: initParamResponse.data.siteId, siteName: "", logoutListner: logout}});
            setValue("questionTemplate", initParamResponse.data.questionTemplate);
            setValue("chatTitle", initParamResponse.data.headerTitle);
            setValue("initMessageList", initParamResponse.data.initTextList.map<ArrayFieldRowType>((value) => { return { msgtext: value.adminMessage }}));
            setValue("headerColor", initParamResponse.data.headerColor);
            setValue("headerTextColor", initParamResponse.data.headerTextColor);
            setValue("backgroundColor", initParamResponse.data.backgroundColor);
            setValue("adminBubbleBackgroundColor", initParamResponse.data.adminBubbleBackgroundColor);
            setValue("adminBubbleTextColor", initParamResponse.data.adminBubbleTextColor);
            setValue("guestBubbleBackgroundColor", initParamResponse.data.guestBubbleBackgroundColor);
            setValue("guestBubbleTextColor", initParamResponse.data.guestBubbleTextColor);
            setValue("footerText", initParamResponse.data.footerText);
            setValue("footerBackgroundColor", initParamResponse.data.footerBackgroundColor);
            setValue("footerTextareaColor", initParamResponse.data.footerTextareaColor);
            setValue("footerTextareaPlaceholderColor", initParamResponse.data.footerTextareaPlaceholderColor);
            setValue("footerTextColor", initParamResponse.data.footerTextColor);
            setValue("headerIcon", CreateFileListFromBlobObject(headerImageResponse.data, "headerIcon"));
            setValue("chatAdminIcon", CreateFileListFromBlobObject(adminIconResponse.data, "chatAdminIcon"));
            setValue("chatGuestIcon", CreateFileListFromBlobObject(guestAdminIconResponse.data, "chatGuestIcon"));
            setValue("sendButtonIcon", CreateFileListFromBlobObject(footerButtonIconResponse.data, "sendButtonIcon"));
        }).catch((e) => {
            setIsLoading(false);
        }).finally(() => {
            setIsLoading(false);
        })
        
        /*const response = await UploadFile<ResponseParam>(ApiUrl.UserFileList, {}, setIsLoading);
        console.log(response.data);                
                setFileList((value) => {return [...response.data.filelist]});
                setTest((value) => {return "aa"});
                setTitle((value) => {return response.data.title});
                setColorlist((value) => {return response.data.colorlist});
                setInittextList((value) => {return response.data.inittextlist.map<ArrayFieldRowType>((value) => {return {msgtext: value}})});
                setBackgroundColor((value) => {return response.data.backgroundcolor});
                setAdminbubblebackgroundcolor((value) => {return response.data.adminbubblebackgroundcolor});
                setAdminbubbletextcolor((value) => {return response.data.adminbubbletextcolor});
                setGuestbubblebackgroundcolor((value) => {return response.data.guestbubblebackgroundcolor});
                setGuestbubbletextcolor((value) => {return response.data.guestbubbletextcolor});
                setFooterBackgroundColor((value) => {return response.data.footerbackgroundcolor});
                setFootertextcolor((value) => {return response.data.footertextcolor});
                setBaseInfoProp((value) => {return {siteId: response.data.siteid, siteName: response.data.sitename}});
        await UploadFile<ResponseParam>(ApiUrl.UserFileList, {}, setIsLoading)
            .then((response) => {
                console.log(response.data);                
                setFileList((value) => {return [...response.data.filelist]});
                setTest((value) => {return "aa"});
                setColorlist((value) => {return response.data.colorlist});
                setBackgroundColor((value) => {return response.data.backgroundcolor});
                setBubbleBackgroundColor((value) => {return response.data.bubblebackgroundcolor});
                setBubbleTextColor((value) => {return response.data.bubbletextcolor});
                setFooterBackgroundColor((value) => {return response.data.footerbackgroundcolor});
                setBaseInfoProp((value) => {return {siteId: response.data.siteid, siteName: response.data.sitename}});
                console.log('init2');
            });*/
    }

    async function getHeaderImage(imageType: UploadImageType, setter: Dispatch<SetStateAction<Blob>>) {
        const response = await UploadFile<Blob>(ApiUrl.GetHeaderImage, { "imageType": imageType }, setIsLoading, "blob");
        setter((value) => { return response.data });
        /*await UploadFile<Blob>(ApiUrl.GetHeaderImage, {}, setIsLoading, "blob")
        .then((response) => {
            setHeaderImage((value) => {
                console.log('init4');
                return response.data//new Blob([response.data], {type:'image/png'});
            });
        });*/
    }

    const [uploadFile, setUploadFile] = useState<FileList | null>();
    const [testFile, setTestFile] = useState<File>();

    const onChangeEvent = (e: ChangeEvent<HTMLInputElement>) => {
        const flie: FileList | null = e.target.files;
        setUploadFile(value => { return flie })
    }

    const onChangeOpenAiSetting = (tokenGaugeData: TokenGaugeData) => {
        console.log(tokenGaugeData);
        setTokenGauge((value) => {return tokenGaugeData});
    }

    const onChangeColor = (color: string, type: ColorType) => {
        switch (type) {
            case ColorType.headercolor:
                setHeadercolor((value) => { return color });
                break;
            case ColorType.headerTextColor:
                setHeaderTextColor((value) => { return color });
                break;
            case ColorType.backgroundColor:
                setBackgroundColor((value) => { return color });
                break;
            case ColorType.adminbubblebackgroundcolor:
                setAdminbubblebackgroundcolor((value) => { return color });
                break;
            case ColorType.adminbubbletextcolor:
                setAdminbubbletextcolor((value) => { return color });
                break;
            case ColorType.guestbubblebackgroundcolor:
                setGuestbubblebackgroundcolor((value) => { return color });
                break;
            case ColorType.guestbubbletextcolor:
                setGuestbubbletextcolor((value) => { return color });
                break;
            case ColorType.footerbackgroundcolor:
                setFooterBackgroundColor((value) => { return color });
                break;
            case ColorType.footertextcolor:
                setFootertextcolor((value) => { return color });
                break;
            case ColorType.footertextareacolor:
                setFooterTextareaColor((value) => { return color });
                break;
            case ColorType.footertextareaplaceholdercolor:
                setFooterTextareaPlaceholderColor((value) => { return color });
                break;
            case ColorType.sendbuttoncolor:
                setSendbuttoncolor((value) => { return color });
                break;
        }
    }

    const onChangeImage = (image: Blob, type: UploadImageType) => {
        switch (type) {
            case UploadImageType.headerImage:
                setHeaderImage((value) => { return image });
                break;
            case UploadImageType.chatAdminIcon:
                setAdminChatIcon((value) => { return image });
                break;
            case UploadImageType.chatGuestIcon:
                setGuestChatIcon((value) => { return image });
                break;
            case UploadImageType.sendButtonIcon:
                setFooterButtonIcon((value) => { return image });
                break;
        }
    }

    const onChangeText = (text: string, type: TextEditType) => {
        switch (type) {
            case TextEditType.chatTitle:
                setTitle((value) => { return text });
                break;
            case TextEditType.footerText:
                setFooterText((value) => { return text });
                break;
        }
    }

    const onChangeMessageList = (message: ArrayFieldRowType[]) => {
        setInittextList((value) => { return message.map<ArrayFieldRowType>((value) => { return { msgtext: value.msgtext } }) });
    }

    const onSubmit: SubmitHandler<IFormInputs> = async (data: IFormInputs, event?: BaseSyntheticEvent) => {
        const response = await UploadFile<ResponseParam>(
            ApiUrl.UpdateConfig,
            data,
            setIsSaving,
        ).then((response) => {
            setIsSnackOpen(true);
        })
    }

    return (
        <>
            {
                isLoading ?
                    <div className={basecss['circularprogress']}>
                        <CircularProgress></CircularProgress>
                    </div>
                    :
                    <>
                        <div className={configcss['configSection']} ref={previewDivRef}>
                            <ChatPreview headercolor={headercolor} headerTitle={title}
                                backgroundColor={backgroundColor}
                                adminbubblebackgroundcolor={adminbubblebackgroundcolor} adminbubbletextcolor={adminbubbletextcolor}
                                guestbubblebackgroundcolor={guestbubblebackgroundcolor} guestbubbletextcolor={guestbubbletextcolor}
                                footerbackgroundcolor={footerBackgroundColor} footertextcolor={footerBackgroundColor}
                                sendbuttoncolor={sendbuttoncolor} footerText={footerText} footerButtonIcon={footerButtonIcon}
                                headerImage={headerImage} chatAdminIcon={adminChatIcon} chatGuestIcon={guestChatIcon}
                                watch={watch}
                                inittextlist={inittextList.map<ChatData>((value) => {
                                    return {
                                        adminMessage: value.msgtext,
                                        adminMessageTime: new Date,
                                        guestMessage: "",
                                        guestMessageTime: new Date,
                                        messageType: ChatMessageType.system,
                                    }
                                })}
                            ></ChatPreview>
                            <div css={sendButton}>
                            <Fab disabled={isSaving} onClick={(e) => { handleSubmit(onSubmit)(e) }}>
                                {
                                    isSaving ? 
                                    <CircularProgress></CircularProgress>
                                    :                                    
                                    <SaveIcon></SaveIcon>
                                }
                                
                            </Fab>
                            </div>
                            <div id={configcss['config']}>                                
                                <BaseInfo siteId={siteProp.siteId} siteName={siteProp.siteName} logoutListner={logout}></BaseInfo> 
                                <UploadFileComponent filelist={fileList} tokenGauge={tokenGauge}></UploadFileComponent>
                                <form onSubmit={(e) => { handleSubmit(onSubmit)(e) }}>
                                <Accordion allowZeroExpanded allowMultipleExpanded className={accordioncss['accordion']}>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                <div style={{display: "inline-flex", alignContent: "flex-start", alignItems: "center" }}>
                                                    {errors.questionTemplate && <img src={erroricon} height={"20px"} width={"20px"}></img>}チャットボットの人格設定
                                                </div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <TextEdit onChangeText={onChangeText} textValue={""} type={TextEditType.questionTemplate}
                                            control={control} register={register} error={errors.questionTemplate} watch={watch}
                                            ></TextEdit>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                <div style={{display: "inline-flex", alignContent: "flex-start", alignItems: "center" }}>
                                                    {errors.chatTitle && <img src={erroricon} height={"20px"} width={"20px"}></img>}チャットタイトル
                                                </div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <TextEdit onChangeText={onChangeText} textValue={""} type={TextEditType.chatTitle}
                                            control={control} register={register} error={errors.chatTitle} watch={watch}
                                            ></TextEdit>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                <div style={{display: "inline-flex", alignContent: "flex-start", alignItems: "center" }}>{errors.initMessageList && <img src={erroricon} height={"20px"} width={"20px"}></img>}初期表示メッセージ</div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <InitMessages onChangeMessageList={onChangeMessageList} messages={inittextList}
                                            control={control} register={register} errors={errors} useFieldArrays={fieldArray}
                                            ></InitMessages>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                ヘッダーアイコン
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <UploadImage headerImage={headerImage} imageType={UploadImageType.headerImage} onChangeImage={onChangeImage}
                                            control={control} register={register} error={errors.headerIcon} watch={watch} setValue={setValue}
                                            ></UploadImage>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                ヘッダー背景色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                        <ColorPicker colorType={ColorType.headercolor} selectedColor={headercolor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                ヘッダー文字色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.headerTextColor} selectedColor={headerTextColor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                チャットエリア背景色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.backgroundColor} selectedColor={backgroundColor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                ボットのチャットアイコン
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <UploadImage headerImage={adminChatIcon} imageType={UploadImageType.chatAdminIcon} onChangeImage={onChangeImage}
                                            control={control} register={register} error={errors.chatAdminIcon} watch={watch} setValue={setValue}
                                            ></UploadImage>
                                        </AccordionItemPanel>
                                    </AccordionItem>                                    
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                ボットの吹き出し背景色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.adminbubblebackgroundcolor} selectedColor={adminbubblebackgroundcolor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                ボットの吹き出し文字色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.adminbubbletextcolor} selectedColor={adminbubbletextcolor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                利用者の吹き出し背景色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.guestbubblebackgroundcolor} selectedColor={guestbubblebackgroundcolor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                利用者の吹き出し文字色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.guestbubbletextcolor} selectedColor={guestbubbletextcolor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                フッター背景色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.footerbackgroundcolor} selectedColor={footerBackgroundColor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>                                    
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                質問入力エリアの背景色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.footertextareacolor} selectedColor={footerTextareaColor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                質問入力エリアの文字色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.footertextcolor} selectedColor={footertextcolor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                <div style={{display: "inline-flex", alignContent: "flex-start", alignItems: "center" }}>{errors.footerText && <img src={erroricon} height={"20px"} width={"20px"}></img>}質問入力エリアの初期メッセージ</div>
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <TextEdit onChangeText={onChangeText} textValue={footerText} type={TextEditType.footerText}
                                            control={control} register={register} error={errors.footerText} watch={watch}
                                            ></TextEdit>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                質問入力エリアの初期メッセージ文字色
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <ColorPicker colorType={ColorType.footertextareaplaceholdercolor} selectedColor={footerTextareaPlaceholderColor} colorList={colorList} onChangeColor={onChangeColor}
                                            control={control} register={register} setValue={setValue} getvalue={getValues}
                                            ></ColorPicker>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                    <AccordionItem className={accordioncss['accordion__item']}>
                                        <AccordionItemHeading className={accordioncss['accordion__heading']}>
                                            <AccordionItemButton className={accordioncss['accordion__button']}>
                                                質問送信アイコン
                                            </AccordionItemButton>
                                        </AccordionItemHeading>
                                        <AccordionItemPanel className={accordioncss['accordion__panel']}>
                                            <UploadImage headerImage={footerButtonIcon} imageType={UploadImageType.sendButtonIcon} onChangeImage={onChangeImage}
                                            control={control} register={register} error={errors.sendButtonIcon} watch={watch} setValue={setValue}
                                            ></UploadImage>
                                        </AccordionItemPanel>
                                    </AccordionItem>
                                </Accordion>
                                </form>
                            </div>
                        </div>
                    </>
            }
            <Snack open={isSnackOpen} setOpen={setIsSnackOpen} duration={6000} message="設定を保存しました。" color="success" anchor={{vertical: "top", horizontal: "left"}}></Snack>
        </>
    );
}